import type { SVGProps } from 'react';
import { forwardRef, Ref } from 'react';

const SvgHangSluitwerk = (
  props: SVGProps<SVGSVGElement>,
  ref: Ref<SVGSVGElement>,
) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 40 40"
    role="img"
    aria-hidden={true}
    ref={ref}
    {...props}
  >
    <path
      fill="#85E3F9"
      d="M32 32.61V7.39A1.39 1.39 0 0 0 30.61 6H9.39A1.39 1.39 0 0 0 8 7.39v25.22c0 .768.622 1.39 1.39 1.39h21.22A1.39 1.39 0 0 0 32 32.61"
    />
    <path
      fill="#00C5F2"
      d="M24.5 16.5a4.5 4.5 0 1 0-5.92 4.25L16.46 30h7.08l-2.12-9.25a4.49 4.49 0 0 0 3.08-4.25"
    />
    <path
      fill="#00215B"
      fillRule="evenodd"
      d="M20 11.668a3.503 3.503 0 0 0-2.476 5.978l-.707.707a4.502 4.502 0 1 1 6.367-6.367l-.707.707A3.5 3.5 0 0 0 20 11.669M21.907 20.638 23.827 29H17.72v-1h4.852l-1.64-7.138z"
      clipRule="evenodd"
    />
  </svg>
);

/* eslint-disable import/no-default-export */
const ForwardRef = forwardRef(SvgHangSluitwerk);

export default ForwardRef;
